import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {WidgetHeaderHidingComponent} from './widget-header-hiding.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        WidgetHeaderHidingComponent
    ],
    exports: [
        WidgetHeaderHidingComponent
    ]
})
export class WidgetHeaderHidingModule {}
